<template>
  <Modal v-model="visible" @on-ok="ok" @on-cancel="cancel" :loading="modalLoading" 
    closable mask-closable :okText="getTranslation('c006')" :cancelText="getTranslation('b182')" :title="title">
    <Row class="field-line" type="flex">
      <Col flex="4" class="desc-field">
      {{ getTranslation('c008') }}<Icon type="md-star" class="need-icon" />
      </Col>
      <Col flex="20">
      <Input v-model="user.name" maxlength="45" :disabled="editId>0" />
      </Col>
    </Row>
    <Row class="field-line" type="flex">
      <Col flex="4" class="desc-field">
      {{ getTranslation('u003') }}<Icon type="md-star" class="need-icon" />
      </Col>
      <Col flex="20">
      <Input v-model="user.nick_name" maxlength="100" />
      </Col>
    </Row>
    <Row class="field-line" type="flex">
      <Col flex="4" class="desc-field">
      {{ getTranslation('u005') }}<Icon type="md-star" class="need-icon" />
      </Col>
      <Col flex="20">
      <Input type="password" password v-model="user.password" maxlength="20" />
      </Col>
    </Row>
    <Row class="field-line" type="flex">
      <Col flex="4" class="desc-field">
      {{ getTranslation('u079') }}<Icon v-if="editId<=0" type="md-star" class="need-icon" />
      </Col>
      <Col flex="20">
      <Input type="password" password v-model="confirmPassword" maxlength="20" />
      </Col>
    </Row>

    <Row class="field-line" type="flex">
      <Col flex="4" class="desc-field">
      {{ getTranslation('u004') }}<Icon type="md-star" class="need-icon" />
      </Col>
      <Col flex="20">
      <Select :transfer="true" v-model="user.role_id" :placeholder="getTranslation('m034')">
        <Option v-for="(item) in role" :value="item.id" :key="item.id">{{ item.name }}</Option>
      </Select>
      </Col>
    </Row>
    <Row class="field-line" type="flex">
      <Col flex="4" class="desc-field">
      {{ getTranslation('m009') }}<Icon type="md-star" class="need-icon" />
      </Col>
      <Col flex="20">
      <Select :transfer="true" v-model="user.state" :placeholder="getTranslation('m034')">
        <Option v-for="(item, key) in StateMap" :value="key" :key="key">{{ item }}</Option>
      </Select>
      </Col>
    </Row>
     <div slot="footer">
        <Row type="flex" class="menu-actions">
          <Col flex="1" class="flex-right">
            <Button type="text" @click="cancel" icon="md-close" >{{ getTranslation('b182') }}</Button>&nbsp;
            <Button type="primary" @click="ok" icon="md-checkmark" >{{ getTranslation('c006') }}</Button>            
          </Col>
        </Row>
      </div>
  </Modal>

</template>
<script>

import { API_URL } from '@/constants/const.js'
import axios from 'axios';
import { mapGetters } from 'vuex'
import { postJsError } from '@/util/util.js'
export default {
  name: 'UserEdit', // 组件名称
  components: {
     
  },
  props: {
    propVisible: Boolean,
    editId: Number
  },
  data() {
    return {
      user: {},
      title: '',
      modalLoading: true,
      originPassword: '**********',
      confirmPassword:'',
      role:[]
    }
  },
  computed: {
    ...mapGetters(['getTranslation']),
    visible: {
      get() { return this.propVisible },
      set(val) { this.$emit('input', val) }
    },
    StateMap() {
      return {
        0: this.getTranslation("u010"),
        1: this.getTranslation("u011"),
        2: this.getTranslation("u012"),
        3: this.getTranslation("m004")
      };
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.getAllRole();
        if (this.editId > 0) {
          this.title = this.getTranslation('u006');          
          this.getOneUser(this.editId)
        } else {
          this.title = this.getTranslation('u002');
          this.user = {            
            state: "1"
          }
        }
      }
    }
  },

  created() {

  },
  methods: {
    getOneUser(id) {
      let url = API_URL["userGetOne"];
      let params = {
        id: id
      }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.user = res.data.data;
            this.user.state = this.user.state.toString();
            this.user.password = this.originPassword;
            this.confirmPassword = ""
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('c001'));
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    getAllRole(){
      let url = API_URL["roleGetAll"];
      let params = {
        
      }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.role = res.data.data;           
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('c001'));
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })

    },
    ok() {
      let _this = this;
      this.modalLoading = true;
      if (!this.validateForm()) {
        this.modalLoading = false;
        this.resetModal();
        return;
      }
      let url = API_URL["userAdd"];

      let params = Object.assign({}, this.user);
      if (this.editId > 0) {
        url = API_URL["userUpdate"];
        if (params.password == this.originPassword) {
          params.password = "";
        }
      }

      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code && res.data.code == 200) {
            if (this.editId > 0) {
              this.$Message.success(this.getTranslation('u018'));
            } else {
              this.$Message.success(this.getTranslation('u019'));
            }
            this.visible = false
            _this.$emit("refresh-page")

          } else if (res && res.data && res.data.code && res.data.msg) {
            this.$Message.error(res.data.msg);
            this.modalLoading = false;
            this.resetModal();
          } else {
            this.modalLoading = false;
            this.resetModal();
          }
        })
        .catch((err) => {
          postJsError(err)
          this.modalLoading = false;
          this.resetModal();
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    validateForm() {
      let errorMsg = '';
      let isValid = true;
      if (!this.user.name) {
        errorMsg = this.getTranslation('u013');
        isValid = false;
      } else if (!this.user.nick_name) {
        errorMsg = this.getTranslation('u014');
        isValid = false;
      } else if (!this.user.password) {
        errorMsg = this.getTranslation('u015');
        isValid = false;
      } else if(this.user.password !=this.originPassword && this.user.password !== this.confirmPassword){
        errorMsg = this.getTranslation('u080');
        isValid = false;  
      } else if (!this.user.role_id) {
        errorMsg = this.getTranslation('u016');
        isValid = false;
      } else if (!this.user.state) {
        errorMsg = this.getTranslation('u017');
        isValid = false;
      }
      if (errorMsg) {
        this.$Message.error(errorMsg);
      }
      return isValid;
    },
    resetModal() {
      this.$nextTick(() => {
        this.modalLoading = true;
      });
    },
    cancel() {
      this.visible = false;
    }
  },

}
</script>

<style scoped>
@import url('../../../assets/style/list.css'); 
.desc-field {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 3%;
  font-size: 0.9rem;
}

.field-line {
  margin-bottom: 8px;
}
</style>